import classNames from "classnames";
import { useEffect } from "react";
import AppLayout from "@/layouts/AppLayout";
import usePageTitle from "@/hooks/usePageTitle";
import { DOMAIN, PERMISSION, useDenyAuthorization, useRequireCapability } from "@/hooks/useCapabilities";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import McpPlaygroundChat from "@/features/mcp-playground/McpPlaygroundChat";
import { isStaffMcpPlaygroundRuntime } from "@/features/mcp-playground/access";
import { useAssumeUser } from "@/providers/AssumeUserProvider";

export default function McpPlaygroundPage() {
  usePageTitle("Chat with Member 360");
  useRequireCapability({ domain: DOMAIN.PEOPLE, permission: PERMISSION.viewPeople });
  useRequireCapability({ domain: DOMAIN.FACILITIES, permission: PERMISSION.viewFacilities });
  const denyAuthorization = useDenyAuthorization();
  const { assumedUser, impersonationError } = useAssumeUser();
  const { isCompactLayout } = useIsCompactLayout();
  const showAssumeUserBanner = !!assumedUser || !!impersonationError;
  // AppLayout applies mb-24 on desktop (non-compact). Fold that margin into the
  // viewport calc so the shell does not exceed 100dvh.
  const reserveBottomChrome = !isCompactLayout;
  const heightClassName = classNames({
    "h-[calc(100dvh-5.5rem)]": !showAssumeUserBanner && !reserveBottomChrome,
    "h-[calc(100dvh-5.5rem-6rem)]": !showAssumeUserBanner && reserveBottomChrome,
    "h-[calc(100dvh-9.5rem)]": showAssumeUserBanner && !reserveBottomChrome,
    "h-[calc(100dvh-9.5rem-6rem)]": showAssumeUserBanner && reserveBottomChrome
  });

  useEffect(() => {
    if (!isStaffMcpPlaygroundRuntime()) {
      denyAuthorization();
    }
  }, [denyAuthorization]);

  return (
    <AppLayout>
      <div className={classNames("mx-auto flex w-full max-w-3xl min-h-0 flex-col pt-4 lg:pt-6", heightClassName)}>
        <McpPlaygroundChat />
      </div>
    </AppLayout>
  );
}
